<template>
  <div>
    <h6 style="margin: 0px !important">{{ SENETTOPLAM }}</h6>
    <p style="color: #ea5455; margin: 0px !important">{{ PUANSENET }}</p>
  </div>
</template>
<script>
import { BBadge } from "bootstrap-vue";
export default {
  components: {
    BBadge,
  },
  data() {
    return {
      SENETTOPLAM: 0.0,
      PUANSENET: 0.0,
    };
  },
  methods: {
    gelenData() {
      this.SENETTOPLAM = this.currencyFormatter(
        this.params.data.SENETTOPLAM,
        "₺"
      );
      this.PUANSENET = this.currencyFormatter(this.params.data.PUANSENET, " ");
    },
    currencyFormatter(currency, sign) {
      if (currency == "") {
        return 0.0;
      } else {
        var parfloat = parseFloat(currency);
        var sansDec = parfloat.toFixed(2);
        var formatted = sansDec.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        return sign + `${formatted}`;
      }
    },
  },
  created() {
    this.gelenData();
  },
};
</script>
